import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { TeamContext } from "../../../context";
import { Phase } from "../../../util/enums";
import { CheerButton, PinkNotification } from "../../atoms";

const SolutionDecksHolder: FC<{}> = () => {
    const { t } = useTranslation();
    const { game } = useContext(TeamContext);
    const isCheerButtonActivated = (game?.phase === Phase.CONFETTI_CELEBRATION);
    const zIndexWhenCheerButtonIsActivated :number = isCheerButtonActivated ? 69 : 1;
    const gameRoundNumber: number = game?.gameInfo?.challengeScore || 0;
    const isAfterRound3: boolean = gameRoundNumber > 3;

    return ( 
        <div className="solution_decks_holder" style={{zIndex: zIndexWhenCheerButtonIsActivated}} >
            <div className={`board_cheer_button__wrapper ${isCheerButtonActivated && "right_side_screeen_instructions_background"}`} >
                {isAfterRound3 && <CheerButton />}
                {isCheerButtonActivated && isAfterRound3 && 
                    <div style={{position: "absolute", zIndex: 1}}>
                        <PinkNotification notificationWidthVW={50} notificationRenderingSide="left" text={t("tipYouCanNowCheerTogetherToCelebrateText")} moveFromTop={-50} /> 
                    </div>
                }
            </div>
        </div>
    );
}

export default SolutionDecksHolder;


